import React from 'react';
import { Link, NavLink, Outlet } from 'react-router-dom';

const navLinkBase =
  'px-3 py-2 rounded-md text-sm font-medium transition-colors';

export const Layout: React.FC = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = React.useState(false);

  const handleToggleMobileMenu = () => {
    setIsMobileMenuOpen((prev) => !prev);
  };

  const handleCloseMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <div className="min-h-screen flex flex-col bg-slate-50 text-slate-900">
      <header className="border-b border-slate-200 bg-white/80 backdrop-blur sticky top-0 z-20">
        <div className="max-w-6xl mx-auto flex items-center justify-between px-4 py-3">
          <Link to="/" className="flex items-center gap-2">
            <img
              src="/images/logo-nettoyage-logement-insalubre-alpes-maritimes-var.png"
              alt="Logo entreprise nettoyage logement insalubre Alpes Maritimes Var"
              className="h-9 w-9 rounded-full object-cover"
            />
            <div className="flex flex-col">
              <span className="text-sm font-semibold tracking-tight">
                Nettoyage Logement Insalubre
              </span>
              <span className="text-xs text-slate-500">
                Alpes Maritimes 06 &amp; Var 83
              </span>
            </div>
          </Link>
          <div className="flex items-center gap-2">
            <nav className="hidden md:flex items-center gap-2">
              <NavLink
                to="/"
                onClick={handleCloseMobileMenu}
                className={({ isActive }) =>
                  `${navLinkBase} ${
                    isActive
                      ? 'bg-primary text-white'
                      : 'text-slate-700 hover:bg-slate-100'
                  }`
                }
              >
                Accueil
              </NavLink>
              <NavLink
                to="/nice-06"
                onClick={handleCloseMobileMenu}
                className={({ isActive }) =>
                  `${navLinkBase} ${
                    isActive
                      ? 'bg-primary text-white'
                      : 'text-slate-700 hover:bg-slate-100'
                  }`
                }
              >
                Nice 06
              </NavLink>
              <NavLink
                to="/var-toulon"
                onClick={handleCloseMobileMenu}
                className={({ isActive }) =>
                  `${navLinkBase} ${
                    isActive
                      ? 'bg-primary text-white'
                      : 'text-slate-700 hover:bg-slate-100'
                  }`
                }
              >
                Var Toulon
              </NavLink>
              <NavLink
                to="/tarifs"
                onClick={handleCloseMobileMenu}
                className={({ isActive }) =>
                  `${navLinkBase} ${
                    isActive
                      ? 'bg-primary text-white'
                      : 'text-slate-700 hover:bg-slate-100'
                  }`
                }
              >
                Tarifs
              </NavLink>
              <NavLink
                to="/blog"
                onClick={handleCloseMobileMenu}
                className={({ isActive }) =>
                  `${navLinkBase} ${
                    isActive
                      ? 'bg-primary text-white'
                      : 'text-slate-700 hover:bg-slate-100'
                  }`
                }
              >
                Blog
              </NavLink>
              <NavLink
                to="/faq"
                onClick={handleCloseMobileMenu}
                className={({ isActive }) =>
                  `${navLinkBase} ${
                    isActive
                      ? 'bg-primary text-white'
                      : 'text-slate-700 hover:bg-slate-100'
                  }`
                }
              >
                FAQ
              </NavLink>
            </nav>

            <button
              type="button"
              onClick={handleToggleMobileMenu}
              className="inline-flex items-center justify-center rounded-md border border-slate-300 p-2 text-slate-700 hover:bg-slate-100 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 focus:ring-offset-white md:hidden"
              aria-label={isMobileMenuOpen ? 'Fermer le menu' : 'Ouvrir le menu'}
              aria-expanded={isMobileMenuOpen}
            >
              <span className="sr-only">
                {isMobileMenuOpen ? 'Fermer le menu' : 'Ouvrir le menu'}
              </span>
              <svg
                className="h-5 w-5"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                {isMobileMenuOpen ? (
                  <path
                    d="M6 18L18 6M6 6l12 12"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                ) : (
                  <path
                    d="M4 6h16M4 12h16M4 18h16"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                )}
              </svg>
            </button>

            <a
              href="https://wa.me/33745171331?text=Bonjour%2C+je+souhaite+un+devis+pour+un+nettoyage+logement+insalubre+dans+le+06+ou+83."
              target="_blank"
              rel="noopener noreferrer"
              className="hidden xs:inline-flex items-center justify-center rounded-md bg-mint px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-emerald-500 transition-colors"
            >
              Devis WhatsApp 24h
            </a>
            <Link
              to="/devis"
              className="hidden sm:inline-flex items-center justify-center rounded-md border border-slate-300 px-3 py-2 text-xs font-medium text-slate-700 hover:bg-slate-100 transition-colors"
            >
              Formulaire devis
            </Link>
          </div>
        </div>

        {isMobileMenuOpen && (
          <div className="md:hidden border-t border-slate-200 bg-white/95">
            <nav className="max-w-6xl mx-auto px-4 py-3 flex flex-col gap-1">
              <NavLink
                to="/"
                onClick={handleCloseMobileMenu}
                className={({ isActive }) =>
                  `${navLinkBase} w-full text-left ${
                    isActive
                      ? 'bg-primary text-white'
                      : 'text-slate-700 hover:bg-slate-100'
                  }`
                }
              >
                Accueil
              </NavLink>
              <NavLink
                to="/nice-06"
                onClick={handleCloseMobileMenu}
                className={({ isActive }) =>
                  `${navLinkBase} w-full text-left ${
                    isActive
                      ? 'bg-primary text-white'
                      : 'text-slate-700 hover:bg-slate-100'
                  }`
                }
              >
                Nice 06
              </NavLink>
              <NavLink
                to="/var-toulon"
                onClick={handleCloseMobileMenu}
                className={({ isActive }) =>
                  `${navLinkBase} w-full text-left ${
                    isActive
                      ? 'bg-primary text-white'
                      : 'text-slate-700 hover:bg-slate-100'
                  }`
                }
              >
                Var Toulon
              </NavLink>
              <NavLink
                to="/tarifs"
                onClick={handleCloseMobileMenu}
                className={({ isActive }) =>
                  `${navLinkBase} w-full text-left ${
                    isActive
                      ? 'bg-primary text-white'
                      : 'text-slate-700 hover:bg-slate-100'
                  }`
                }
              >
                Tarifs
              </NavLink>
              <NavLink
                to="/blog"
                onClick={handleCloseMobileMenu}
                className={({ isActive }) =>
                  `${navLinkBase} w-full text-left ${
                    isActive
                      ? 'bg-primary text-white'
                      : 'text-slate-700 hover:bg-slate-100'
                  }`
                }
              >
                Blog
              </NavLink>
              <NavLink
                to="/faq"
                onClick={handleCloseMobileMenu}
                className={({ isActive }) =>
                  `${navLinkBase} w-full text-left ${
                    isActive
                      ? 'bg-primary text-white'
                      : 'text-slate-700 hover:bg-slate-100'
                  }`
                }
              >
                FAQ
              </NavLink>
              <Link
                to="/devis"
                onClick={handleCloseMobileMenu}
                className={`${navLinkBase} w-full text-left border border-slate-200 mt-1 text-slate-700 hover:bg-slate-50`}
              >
                Demander un devis
              </Link>
            </nav>
          </div>
        )}
      </header>

      <main className="flex-1">
        <Outlet />
      </main>

      <footer className="border-t border-slate-200 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-6 text-xs text-slate-500 flex flex-col md:flex-row md:items-center md:justify-between gap-3">
          <p>
            © {new Date().getFullYear()} Nettoyage logement insalubre Alpes
            Maritimes 06 &amp; Var 83. Tous droits réservés.
          </p>
          <p>
            Intervention 7j/7 - Nice, Cannes, Antibes, Toulon, Fréjus,
            Draguignan · Tel / WhatsApp :{' '}
            <a
              href="https://wa.me/33745171331"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary font-semibold"
            >
              +33 7 45 17 13 31
            </a>
          </p>
        </div>
      </footer>
    </div>
  );
};
